import * as React from "react";
function SvgPolygonFunnel(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M23.997 6l-6-6h14l-6 5.999v6h-2V6zm.652 14.47l1.696 1.06L21.051 30H7.983L1.45 18.5 7.983 7h7.514v2h-6.35L3.75 18.5 9.147 28h10.796l4.706-7.53zM22.826 2l2.171 2.171L27.169 2h-4.343z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPolygonFunnel);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
